module.exports = __webpack_public_path__ + "media/images/logout-143e04bacd22182e739686ef3536d442.svg";